import Vue from 'vue';
import DashboardPlugin from './plugins/dashboard-plugin';
import App from './App.vue';
import '@/app/utils/auth'
// router setup
//import router from './routes/starterRouter';
import router from './app/routes/routes';
// plugin setup
Vue.use(DashboardPlugin);

import Vuelidate from 'vuelidate'
Vue.use(Vuelidate)

import Toaster from 'v-toaster'

// You need a specific loader for CSS files like https://github.com/webpack/css-loader
import 'v-toaster/dist/v-toaster.css'

import * as $ from 'jquery'
import 'tooltipster'
import 'tooltipster/dist/css/tooltipster.bundle.css'
import 'tooltipster/dist/css/plugins/tooltipster/sideTip/themes/tooltipster-sideTip-borderless.min.css'
import VueClip from 'vue-clip'

import VueSnackbar from 'vue-snack' 
import 'vue-snack/dist/vue-snack.min.css'

Vue.use(VueSnackbar, { position: 'bottom', time: 3000 })

//lightbox
require('./libs/lightbox/style.css')
import VueLazyLoad from 'vue-lazyload'
Vue.use(VueLazyLoad)
//end light box

//import VTooltip from 'v-tooltip'

import { VTooltip, VPopover, VClosePopover } from 'v-tooltip'

Vue.directive('tooltip', VTooltip)


import VueTextareaAutogrowDirective from 'vue-textarea-autogrow-directive'

Vue.use(VueTextareaAutogrowDirective)
// import '@fortawesome/fontawesome-free/css/all.css'
// import '@fortawesome/fontawesome-free/js/all.js'

import PortalVue from 'portal-vue'
Vue.use(PortalVue)

Vue.use(VueClip)
// optional set default imeout, the default is 10000 (10 seconds).
Vue.use(Toaster, { timeout: 5000 })

import store from './app/store'

window.$ = require('jquery')
/* eslint-disable no-new */
new Vue({
  el: '#app',
  render: h => h(App),
  router,
  store
});

$(document).ready(function () {
  $(".tf__init--popup .btn-close").click(function () {
    $(".tf__init--popup").css("display", "none");
  });
});

